<template>
    <div class="list-group-item">
        <div class="row text-left">
            <div class="col-6 align-self-center">
                <AppUserAvatar :user="user" withRightCaption/>
            </div>
            <div class="col-5 align-self-center pl-0">
                <AppDocPermissionSelect
                    :value="source.permission"
                    @input="onPermissionChange"
                    :isLoading="isUpdating"
                    :permissionKeys="availablePermissionKeys"
                    appendDropdownToBody/>
            </div>
            <div class="col-1 align-self-center">
                <span v-show="isRemoving">
                    <i class="fas fa-spinner fa-pulse"></i>
                </span>
                <span v-show="!isRemoving"
                      @click="deleteUser"
                      class="text-danger clickable">
                    <i class="fal fa-trash-alt"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {DOCS_TYPES_SELECTED_UPDATE_PROP, DOCS_TYPES_SET} from '@/store/modules/documents'
import AppUserAvatar from '../../../../components/setters/AppUserAvatar'
import AppDocPermissionSelect from '@/views/documents/types/permissions/AppDocPermissionSelect.vue'
import {documentTypesApiService} from '@/api/document/types'
import {AppDocPermissions} from '@/types/permissions/document'

export default {
    name: 'DtPermissionMemberRow',
    components: {AppDocPermissionSelect, AppUserAvatar},
    props: {
        source: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isRemoving: false,
            isUpdating: false
        }
    },
    computed: {
        ...mapGetters([
            'isAdminOrStaff'
        ]),

        ...mapGetters('documents', {
            documentTypes: 'documentTypes',
            dt: 'documentTypeSelected'
        }),

        user() {
            return this.source.user || {}
        },

        availablePermissionKeys() {
            if (['PRODUCT', 'CONTACT'].includes(this.dt.index)) {
                return [AppDocPermissions.FULL, AppDocPermissions.READ_ONLY]
            }
            return [] // all
        }
    },
    methods: {
        ...mapMutations('documents', {
            setDocTypes: DOCS_TYPES_SET,
            updateDtProp: DOCS_TYPES_SELECTED_UPDATE_PROP
        }),

        onPermissionChange(permission) {
            if (!permission) {
                return
            }
            this.isUpdating = true
            documentTypesApiService.updateUser({
                id: this.dt.uuid,
                userId: this.user.uuid,
                permission
            })
                .then(() => {
                    this.updateDtProp({
                        path: ['permissions', this.user.uuid],
                        data: permission
                    })
                })
                .catch(error => {
                    this.$snackbar.show({error})
                })
                .finally(() => {
                    this.isUpdating = false
                })
        },

        deleteUser() {
            this.isRemoving = true
            documentTypesApiService.deleteUser({id: this.dt.uuid, userId: this.user.uuid})
                .then(() => {
                    let permissions = _.cloneDeep(this.dt.permissions)
                    delete permissions[this.user.uuid]
                    this.updateDtProp({path: `permissions`, data: permissions})

                    const dIdx = this.documentTypes.findIndex(dt => dt.uuid === this.dt.uuid)
                    if (dIdx !== -1) {
                        this.documentTypes[dIdx].permissions = permissions
                    }
                    this.setDocTypes(this.documentTypes)
                })
                .catch(error => {
                    this.$snackbar.show({error})
                })
                .finally(() => {
                    this.isRemoving = false
                })
        },

        addUser() {
            this.$modal.show('add-user')
        }
    }
}
</script>

<style scoped lang="scss">
.container-wrap {
    height: calc(100% - 80px);
    background: white;
    overflow-y: scroll;
    @include media-breakpoint-down(sm) {

    }
}

#permission-list {
    height: 350px;
}

.list-group-item {
    border-top: 1px solid rgba(0, 0, 0, .1);
    border-left: none;
    border-right: none;
    border-bottom: none;
}

.list-group-item:first-child {

    border-top: none;
}

/*.list-group-item:last-child {*/

/*border-bottom:none;*/
/*}*/

</style>
